<template>
  <!-- eslint-disable vue/first-attribute-linebreak, vue/max-attributes-per-line -->
  <div class="privacy-policy">
    <div class="privacy-policy__header">
      <div class="privacy-policy__title">
        Политика в области обработки и обеспечения защиты персональных данных
      </div>
      <div class="privacy-policy__date">
        Дата публикации: <time class="privacy-policy__date-value">01.09.2026</time>
      </div>
    </div>
    <ul class="privacy-policy__list">
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">1. Общие положения</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            1.1. Настоящая Политика ООО «ЛИГАЛ АДС ТЕХ» (ОГРН 1227700103245, ИНН
            9709078420, далее — Оператор) описывает принципы и подходы Оператора в
            отношении обработки и защиты персональных данных (далее — ПДн), обязанности и
            ответственность Оператора при их обработке и защите.
          </p>
          <p class="privacy-policy__item-paragraph">
            1.2. Политика применяется к сайту jurik.ru (далее — Сайт) и связанным с ним
            сервисам Оператора, а также к обращениям, поступающим Оператору по телефону и
            через информационные ресурсы партнёров Оператора.
          </p>
          <p class="privacy-policy__item-paragraph">
            1.3. Оператор обеспечивает соблюдение прав и свобод граждан при обработке ПДн
            и принимает меры для выполнения обязанностей, предусмотренных Федеральным
            законом от 27.07.2006 № 152-ФЗ «О персональных данных» и принятыми в
            соответствии с ним нормативными правовыми актами.
          </p>
          <p class="privacy-policy__item-paragraph">
            1.4. Запросы, связанные с обработкой ПДн, в том числе запросы субъектов ПДн и
            отзыв согласий, направляются Оператору: по электронной почте
            <a class="privacy-policy__item-link" href="mailto:info@jurik.ru"
              >info@jurik.ru</a
            >
            либо почтой по юридическому адресу Оператора.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">2. Субъекты ПДн</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            Оператор обрабатывает ПДн следующих категорий субъектов: посетители и
            пользователи Сайта; посетители сайтов и приложений, на которых размещены
            рекламные материалы jurik.ru; заказчики (клиенты) — лица, обращающиеся за
            подбором специалиста, записью на консультацию, юридической консультацией или с
            иным обращением, в том числе по телефону; специалисты (юристы, адвокаты,
            представители юридических компаний и адвокатских образований), разместившие
            профиль на Сайте; контрагенты и партнеры Оператора и их представители.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">3. Цели обработки ПДн</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            Обработка осуществляется в целях: предоставления доступа к функциональным
            возможностям Сайта; заключения и исполнения договоров; приема, оформления и
            сопровождения обращений заказчиков независимо от способа их поступления
            (записи на консультации, заявки на подбор специалиста, заявки на услуги,
            вопросы, телефонные обращения), включая уведомления об их статусе; подбора
            исполнителя по обращению заказчика и распределения обращений между
            специалистами и партнерами Оператора, в том числе на конкурентной основе;
            организации оказания заказчикам юридических консультаций и иной юридической
            помощи; связи с субъектами по вопросам их обращений, в том числе по телефону;
            записи телефонных разговоров с операторами Оператора в целях контроля качества
            обслуживания и подтверждения фактов обращений (с уведомлением в начале
            разговора); верификации специалистов; анализа эффективности Сайта и рекламных
            каналов; направления сообщений рекламного и информационного характера (при
            наличии соответствующего согласия); реализации прав и обязанностей,
            предусмотренных законодательством Российской Федерации.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">4. Категории обрабатываемых ПДн</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            4.1. В отношении заказчиков: фамилия, имя, отчество (при указании); номер
            телефона; адрес электронной почты; регион; содержание запросов и обращений;
            сведения о записях на консультации и иных обращениях; аудиозаписи телефонных
            разговоров с операторами Оператора; IP-адрес, файлы cookies, данные
            метрических программ.
          </p>
          <p class="privacy-policy__item-paragraph">
            4.2. В отношении специалистов: фамилия, имя, отчество; адрес электронной
            почты; номер телефона; сведения об образовании и профессиональном статусе;
            ИНН; паспортные данные (в объеме, необходимом для верификации); фотографии;
            адрес места приема; платёжные данные; сведения о записях; аудиозаписи
            телефонных разговоров; IP-адрес, файлы cookies, данные метрических программ.
          </p>
          <p class="privacy-policy__item-paragraph">
            4.3. Оператор не обрабатывает специальные категории ПДн и биометрические ПДн.
            Содержание юридического вопроса заказчика обрабатывается исключительно для
            подбора исполнителя, передачи вопроса исполнителю и сопровождения обращения.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">5. Правовые основания обработки</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            Правовыми основаниями обработки являются: Конституция Российской Федерации;
            Федеральный закон № 152-ФЗ «О персональных данных»; договоры, заключаемые с
            субъектами ПДн; согласия субъектов ПДн на обработку ПДн, включая отдельные
            согласия на распространение ПДн специалистов.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">6. Порядок и условия обработки</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            6.1. Обработка осуществляется с соблюдением принципов и правил,
            предусмотренных 152-ФЗ, автоматизированным и неавтоматизированным способами.
          </p>
          <p class="privacy-policy__item-paragraph">
            6.2. Обработка осуществляется с согласия субъекта ПДн, если иное не
            предусмотрено законодательством Российской Федерации.
          </p>
          <p class="privacy-policy__item-paragraph">
            6.3. Согласие может быть отозвано субъектом ПДн в порядке, указанном в п. 1.4
            Политики. В случае отзыва Оператор прекращает обработку и уничтожает ПДн в
            установленные законом сроки, за исключением случаев, когда обработка может
            быть продолжена на основаниях, предусмотренных законом.
          </p>
          <p class="privacy-policy__item-paragraph">
            6.4. При достижении целей обработки Оператор прекращает обработку и уничтожает
            ПДн в срок, не превышающий 30 дней, если иное не предусмотрено договором или
            законом.
          </p>
          <p class="privacy-policy__item-paragraph">
            6.5. К обработке допускаются только работники Оператора, в чьи обязанности она
            входит, в необходимом им объеме.
          </p>
          <p class="privacy-policy__item-paragraph">
            6.6. Оператор вправе поручить обработку ПДн другому лицу на основании договора
            поручения обработки. Обработчики действуют по указаниям Оператора и обязаны
            соблюдать требования 152-ФЗ. К обработчикам относятся, в частности: провайдеры
            хостинга; операторы связи и сервисы телефонии (обеспечение звонков и их
            записи); поставщики CRM-систем и систем обработки обращений; сервисы рассылок;
            поставщики аналитических услуг.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">7. Передача ПДн третьим лицам</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            7.1. Оператор не раскрывает и не распространяет ПДн без согласия субъекта,
            если иное не предусмотрено федеральным законом.
          </p>
          <p class="privacy-policy__item-paragraph">
            7.2. Контактные данные заказчика и содержание его обращения передаются
            специалисту, выбранному заказчиком, для исполнения обращения.
          </p>
          <p class="privacy-policy__item-paragraph">
            7.3. Если обращение заказчика не адресовано конкретному специалисту, Оператор
            вправе передавать ПДн заказчика (имя, номер телефона, адрес электронной почты,
            регион, содержание обращения) специалистам, разместившим профиль на Сайте, а
            также юристам и юридическим компаниям — партнерам Оператора, привлекаемым для
            оказания заказчикам юридической помощи на основании договоров, содержащих
            условия о конфиденциальности и обеспечении безопасности ПДн.
          </p>
          <p class="privacy-policy__item-paragraph">
            7.4. До принятия обращения в работу конкретным специалистом или партнёром
            сведения об обращении предоставляются им в объеме, не позволяющем
            идентифицировать заказчика (регион, категория вопроса, существо обращения без
            контактных данных). Контактные данные заказчика раскрываются только тому
            специалисту или партнёру, который принял обращение в работу.
          </p>
          <p class="privacy-policy__item-paragraph">
            7.5. Доступ к ПДн предоставляется уполномоченным государственным органам по их
            запросам в установленном законом порядке.
          </p>
          <p class="privacy-policy__item-paragraph">
            7.6. Сведения профиля специалиста распространяются (публикуются) исключительно
            на основании отдельного согласия специалиста на распространение ПДн.
          </p>
          <p class="privacy-policy__item-paragraph">
            7.7. Трансграничная передача ПДн не осуществляется; данные хранятся на
            серверах, расположенных на территории Российской Федерации.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">8. Меры защиты ПДн</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            Оператор принимает необходимые правовые, организационные и технические меры
            защиты ПДн от неправомерного доступа, уничтожения, изменения, блокирования,
            копирования, предоставления и распространения: определение угроз безопасности;
            разграничение прав доступа; применение средств защиты информации; контроль за
            принимаемыми мерами; назначение лица, ответственного за организацию обработки
            ПДн.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">9. Права субъектов ПДн</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            Субъект ПДн вправе: получать сведения об обработке своих ПДн; требовать
            уточнения, блокирования или уничтожения неполных, устаревших, неточных или
            незаконно полученных ПДн; отзывать согласие на обработку; обжаловать действия
            Оператора в уполномоченный орган по защите прав субъектов ПДн или в суд;
            реализовывать иные права, предусмотренные законодательством. Запросы
            направляются в порядке п. 1.4.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">
          10. Файлы cookies и метрические программы
        </div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            10.1. При первом посещении Сайта пользователю отображается баннер об
            использовании cookies. Согласие предоставляется активным действием
            пользователя (нажатие кнопки согласия). Пользователь может ограничить
            использование cookies в настройках браузера; это может повлиять на работу
            отдельных функций Сайта.
          </p>
          <p class="privacy-policy__item-paragraph">
            10.2. На Сайте используется сервис веб-аналитики «Яндекс.Метрика»; данные
            передаются и хранятся на серверах Яндекса в Российской Федерации и
            обрабатываются в соответствии с опубликованными политиками Яндекса.
          </p>
          <p class="privacy-policy__item-paragraph">
            10.3. Используемые виды cookies: обязательные (работа Сайта), сессионные,
            постоянные (настройки и идентификация при повторных визитах), статистические
            (анализ использования Сайта).
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">
          11. Уточнение, блокирование и уничтожение ПДн
        </div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            11.1. При выявлении неправомерной обработки по обращению субъекта Оператор
            блокирует соответствующие ПДн на период проверки; при выявлении неточных ПДн —
            блокирует их на период проверки, если это не нарушает права иных лиц.
          </p>
          <p class="privacy-policy__item-paragraph">
            11.2. При подтверждении неточности Оператор уточняет ПДн в течение 7 рабочих
            дней и снимает блокирование. При выявлении неправомерной обработки Оператор
            прекращает её в срок не более 3 рабочих дней. Если обеспечить правомерность
            невозможно, ПДн уничтожаются в срок не более 10 рабочих дней. Об устранении
            нарушений или уничтожении ПДн Оператор уведомляет субъекта.
          </p>
          <p class="privacy-policy__item-paragraph">
            11.3. Сроки уничтожения: не более 30 дней с даты достижения цели обработки; не
            более 30 дней с даты отзыва согласия; не более 10 рабочих дней с даты
            получения требования о прекращении обработки (с возможным продлением не более
            чем на 5 рабочих дней). При невозможности уничтожения в установленные сроки
            ПДн блокируются и уничтожаются в срок не более 6 месяцев.
          </p>
        </div>
      </li>
      <li class="privacy-policy__item">
        <div class="privacy-policy__item-title">12. Изменение Политики</div>
        <div class="privacy-policy__item-text">
          <p class="privacy-policy__item-paragraph">
            12.1. Оператор вправе изменять Политику. Новая редакция публикуется на Сайте с
            указанием даты публикации и вступает в силу с момента размещения, если иное не
            предусмотрено новой редакцией.
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.privacy-policy {
  .flex-column(@size-x10);

  &__header {
    .flex-column(@size-x3);
  }

  &__title {
    .h-offset-reset();

    font-size: @size-x8;
    font-weight: 700;
    line-height: 130%;
  }

  &__date {
    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
    color: @color-dove-gray;
  }

  &__list {
    .flex-column(@size-x10);

    max-width: 997px;
  }

  &__item {
    .flex-column(@size-x6);
  }

  &__item-title {
    .h-offset-reset();

    font-size: @size-x6;
    font-weight: 700;
    line-height: 130%;
  }

  &__item-text {
    .flex-column(@size-x4);
  }

  &__item-paragraph {
    .p-offset-reset();

    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
  }

  &__item-link {
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
